<template>
  <div>
    <!-- 確認成功模板 -->
    <div
      id="CheckOk"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="CheckOkTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header">
            <h5
              id="CheckOkTitle"
              class="modal-title"
            >
              <font-awesome-icon
                icon="check-circle"
                style="color: #0069ff;"
                size="1x"
              />
              成功
            </h5>
          </div>
          <div class="modal-body content-color">
            {{ data }}
          </div>
          <div class="modal-footer content-color">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 失敗模板 -->
    <div
      id="CheckError"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="CheckErrorTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header">
            <h5
              id="CheckErrorTitle"
              class="modal-title"
            >
              <font-awesome-icon
                icon="exclamation-triangle"
                style="color: #ff0000;"
                size="1x"
              />
              提醒
            </h5>
          </div>
          <div class="modal-body content-color">
            <span v-html="data" />
            <!-- {{ data }} -->
          </div>
          <div class="modal-footer content-color">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalAlert',
  data () {
    return {
      data: ''
    }
  },
  methods: {
    updateMessage (data) {
      this.data = data
    }
  },
  created () {
    const vm = this
    vm.$bus.$on('Modals', data => {
      vm.updateMessage(data)
    })
  }
}
</script>
